export default "__VITE_ASSET__BZwPuyQ___"